export default __webpack_public_path__ + "1ce2fc942556401258436dc9a67e15e4.png";